import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@one-thd/sui-atomic-components';

export const FileUploadError = ({ errorMessage }) => {
  const handleClose = (event) => {
    const alert = event?.currentTarget?.closest('[role="alert"]');
    if (alert) alert.remove();
  };

  return (
    <div className="sui-mb-3">
      <Alert status="error" onClose={handleClose}>{errorMessage}</Alert>
    </div>
  );
};

FileUploadError.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};
